import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
  useContext,
} from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BASE_PATH } from ".././../constants/Global";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector, useDispatch } from "react-redux";
import Navigationtitle from "../include/Navigationtitle";
import DataService from ".././../services/tutorial.service";
import ExternalDataService from ".././../services/external.service";
import {
  playerlistData,
  setisfirsttime,
  actlistData,
} from "../../actions/index";
import Demo from "../crop/Demo";
import { decode } from "base-64";
import { FirebaseContext } from "../../FirebaseContext";
import { Image, Shimmer } from "react-shimmer";
import { playerdefaultLogo } from "../../constants/Images";
import { useMediaQuery } from "react-responsive";
import $ from "jquery";
import moment from "moment";
import {
  getDatabase,
  ref,
  remove,
  onValue,
  set,
  update,
} from "firebase/database";
import {
  logPlayerImgUpload,
  logPlayerImgFailure,
  pickApiMessage,
  redactPresignedInApiPayload,
  summarizePresignedUrl,
  getCroppedImageSourceInfo,
} from "../../utils/playerImgUploadLog";
import ImageCropper1 from "../cropper/ImageCropper";
import ImageCropper2 from "../utils/Demo";
import { bat } from "../../constants/Images";
import { ball } from "../../constants/Images";
import { wkeeper } from "../../constants/Images";
import styled from "styled-components";

// Styled components for QR payment section
const QRContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  background-color: #f9f9f9;
`;

const QRImageWrapper = styled.div`
  text-align: left;
  margin-right: 20px;
`;

const QRImage = styled.img`
  width: 130px;
  height: 130px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 5px;
  background-color: white;
`;

const QRDetailsWrapper = styled.div`
  flex: 1;
  text-align: left;
`;

const QRSectionTitle = styled.h4`
  margin: 0 0 15px 0;
  color: #333;
  font-size: 16px;
  font-weight: bold;
`;

const QRDetailRow = styled.div`
  margin-bottom: 8px;
`;

const QRDetailLabel = styled.label`
  font-weight: bold;
  color: #555;
  display: inline-block;
  width: 100px;
`;

const QRDetailValue = styled.span`
  color: #333;
`;

const QRFeeValue = styled.span`
  color: #e53e3e;
  font-weight: bold;
`;

const QRInstructions = styled.div`
  margin-top: 15px;
  font-size: 13px;
  color: #666;
`;

// Use img as-is if full URL or data URL (e.g. from JoinauctionCode3 direct upload); else path + img
const getPlayerImgUrl = (path, img) => {
  if (!img || img === "") return "";
  if (img.startsWith("http://") || img.startsWith("https://") || img.startsWith("data:")) return img;
  return path + img;
};

function Editplayers(match) {
  const dispatch = useDispatch();
  const getpageData = useSelector((state) => state.setplayerlistData);
  const getTeamList = useSelector((state) => state.setteamlistData);
  const getaucpageData = useSelector((state) => state.setactlistData);
  const aucmoredetail = useSelector((state) => state.actmoredata);

  const [startDate, setStartDate] = useState(new Date());
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
  } = useForm();
  const [isDisabled, setDisabled] = useState(false);
  const loginuser = useSelector((state) => state.setUserlog);
  const { upddata } = useContext(FirebaseContext);
  const isfirsttime = useSelector((state) => state.isfirsttime);
  const [sp3, setsp3] = useState("");
  const [othersp3, setOthersp3] = useState(false);
  const aid = localStorage.getItem("auction_id");
  const [auctype, setauctype] = useState(
    getaucpageData != 0 &&
    getaucpageData.responsedata.list.filter((ele) => ele.aid == aid)[0]
      .acttype
  );
  const [extra, setextra] = useState(aucmoredetail?.extra);
  const [runwkt, setRunwkt] = useState(null);
  const [pyqr, setPyqr] = useState(null);

  const [otherSp1, setOtherSp1] = useState(false);
  const [otherSp1Value, setOtherSp1Value] = useState("");
  const [otherSp2, setOtherSp2] = useState(false);
  const [otherSp2Value, setOtherSp2Value] = useState("");
  const [otherSp3, setOtherSp3] = useState(false);
  const [otherSp3Value, setOtherSp3Value] = useState("");


  const [batting, setBatting] = useState("");
  const [other, setother] = useState("");
  const [other2, setother2] = useState("");
  const [other3, setother3] = useState("");
  const [bowling, setBowling] = useState("");
  const [otherBatting, setOtherBatting] = useState(false);
  const [otherBowling, setOtherBowling] = useState(false);
  const [croppedImage, setCroppedImage] = useState("");
  const [originalFileName, setOriginalFileName] = useState("");
  const [defimg, setdefimg] = useState(playerdefaultLogo);

  const [playimg, setPlayimg] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  const [isOwner, setIsOwner] = useState("");
  const [defaultIsOwner, setDefaultIsOwner] = useState(false);
  const [isNonPlayer, setIsNonPlayer] = useState(false);
  const [playerSoldToTeam, setPlayerSoldToTeam] = useState(false);
  const [points, setPoints] = useState("0");

  const [playingStyle, setPlayingStyle] = useState("");

  const [isbat, setisbat] = useState(false);
  const [isbol, setisbol] = useState(false);
  const [iswkeep, setiswkeep] = useState(false);
  const isShow = (val) => Number(val) === 1;


  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const isPortrait = useMediaQuery({ query: "(orientation: portrait)" });
  const customTagRef = useRef("");
  const history = useHistory({ forceRefresh: true });
  const { pid } = useParams();
  const [cid, setCid] = useState(loginuser["cid"] || 0);
  const [catData, setcatData] = useState([]);
  const [catid, setcatid] = useState("");
  const [tagid, settagid] = useState("0");
  const [customTag, setCustomTag] = useState("");
  const sp1opt = [
    "All Rounder",
    "Batting All Rounder",
    "Bowling All Rounder",
    "All Rounder Wicketkeeper",
    "Batsman",
    "Bowler",
    "Wicket Keeper",
    "Batter",
    "Other",
    "",
  ];
  const [sp1Value, setSp1Value] = useState("");
  const [sp2Value, setSp2Value] = useState("");
  const [sp3Value, setSp3Value] = useState("");
  const BASE_FILE_PATH = "https://mscsuper.blr1.digitaloceanspaces.com/receipt/";
  const valueWatch = watch();


  const updtoken = useSelector((state) => state.updtoken);
  const sp2opt = [
    "Right Hand",
    "Left Hand",
    "Right Hand Batsman",
    "Left Hand Batsman",
    "Right Hand Opener",
    "Left Hand Opener",
    "Right Hand Middle Order",
    "Left Hand Middle Order",
    "Other",
    "",
  ];
  const sp3opt = [
    "Right Arm Fast",
    "Right Arm Medium",
    "Left Arm Fast",
    "Left Arm Medium",
    "Off-Break",
    "Leg-Break",
    "Left Arm Orthodox",
    "Left Arm Chinaman",
    "Other",
    "",
  ];
  const [checklist, setschecklist] = useState([
    "Bowler",
    "Bowling All Rounder",
  ]);
  const [checklist1, setschecklist1] = useState([
    "All Rounder",
    "Batting All Rounder",
    "All Rounder Wicketkeeper",
    "Batsman",
    "Wicket Keeper",
    "Batter",
    "Other",
    "",
  ]);
  const [checklist2, setschecklist2] = useState([
    "Bowler",
    "Bowling All Rounder",
  ]);

  let logo_pic = "";

  const fetchcatData = async () => {

    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, token: loginuser["token"] },
        ]),
      },
    };

    await DataService.listCategory({ aid: aid }, hdr)
      .then((res) => {
        let response = res.data;
        //  // // console.log(response);

        if (response.success == true) {
          let responsedata = response.data;
          //  // // console.log(" cat list kya h");
          //  // // console.log(responsedata);
          setcatData(responsedata.list);
        }
        // setActive(false);
      })
      .catch(() => {
        //  // // console.log('Not valid')
        // setActive(false);
      });
  };
  const onSubmit = async (values) => {
    if (isUploading) return;

    setIsUploading(true);
    if (tagid === "7" && !customTag.trim()) {
      toast.error("Custom tag is required when Other is selected", {
        theme: "colored",
      });
      setIsUploading(false);
      return;
    }
    if (playerSoldToTeam && (!isOwner || isOwner === "" || Number(isOwner) < 1)) {
      toast.error("Please select a team when Player sold to team is checked", {
        theme: "colored",
      });
      setIsUploading(false);
      return;
    }

    setDisabled(true);
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
    });
    if (document.getElementById("logo_pic") != null) {
      logo_pic = document.getElementById("logo_pic").value;
    }

    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };

    var icon = "";
    if (isbat == true) icon = icon ? icon + ",bat.png" : "bat.png";
    if (isbol == true) icon = icon ? icon + ",ball.png" : "ball.png";
    if (iswkeep == true) icon = icon ? icon + ",gloves.png" : "gloves.png";

    values["icons"] = icon;
    values["isowner"] = isOwner;
    values["isnonplay"] = isNonPlayer;
    values["player_sold_to_team"] = playerSoldToTeam ? "1" : "0";
    values["points"] = points !== "" ? points : "0";

    // ******* ✔ FIXED SPECIFICATIONS LOGIC *******
    // if (auctype == 0) {
    //   // spcf1
    //   if (values.spcf1 === "Other") {
    //     values.spcf1 = bowling || "";
    //   }

    //   // spcf2
    //   if (values.spcf2 === "Other") {
    //     values.spcf2 = otherBatting || "";
    //   }

    //   // spcf3
    //   if (values.spcf3 === "Other") {
    //     values.spcf3 = otherBowling || "";
    //   }
    // }
    if (auctype == 0) {
      if (values.spcf1 !== "Other") {
        setother("");
        values["spcf1"] = batting;
      } else {
        //  // // console.log('trigger')
        values["spcf1"] = other;
      }
      if (values.spcf2 !== "Other") {
        setother2("");
        values["spcf2"] = bowling;
      } else {
        values["spcf2"] = other2;
      }
      if (values.spcf3 !== "Other") {
        setother3("");
        values["spcf3"] = sp3;
      } else {
        values["spcf3"] = other3;
      }
    }
    // ******* END FIX *******


    values["ownertag"] = tagid === "other" ? "7" : tagid || "0";
    values.cus_tag = customTag.trim();

    if (runwkt && runwkt.length > 0) {
      Object.keys(values).forEach((key) => {
        if (key.startsWith("extra_")) {
          const index = parseInt(key.split("_")[1]);
          if (index >= runwkt.length) delete values[key];
        }
      });

      runwkt.forEach((item, index) => {
        values[`extralb_${index}`] = item.N;
      });
    } else if (extra && extra.length > 0) {
      extra.forEach((item, index) => {
        values[`extralb_${index}`] = item.l;
      });
    }

    if (croppedImage && croppedImage !== "" && croppedImage !== "#") {
      // Use auction detail (aucmoredetail) from Redux – already loaded from /dataapi/auction/detail for this aid; no extra API call.
      // data.no_presignimg === 1 → bypass S3, direct server upload; otherwise use S3 presigned.
      const noPresignImg = aucmoredetail?.data?.no_presignimg ?? aucmoredetail?.no_presignimg;
      if (noPresignImg !== 1) {
        const filename = originalFileName;
        const imgLogCtx = { logContext: "Editplayers" };
        const formData = new FormData();
        formData.append("filename", filename);
        formData.append("fltyp", "playerimg");

        logPlayerImgUpload("presign_flow_start", {
          ...imgLogCtx,
          aid,
          playerIdRoute: decode(pid),
          playerIdForm: values.pid,
          requestedFilename: filename,
          fltyp: "playerimg",
          cropSource: getCroppedImageSourceInfo(croppedImage),
          noPresignImg,
        });

        let externalResponse;
        try {
          externalResponse = await ExternalDataService.getSignedUrl(
            formData,
            hdr
          );

          logPlayerImgUpload("presign_api_http_done", {
            httpStatus: externalResponse?.status,
            apiSuccess: externalResponse?.data?.success,
            apiBodyRedacted: redactPresignedInApiPayload(externalResponse?.data),
          });

          if (externalResponse.data.success == true) {
            const presignPayload = externalResponse.data.data;
            if (!presignPayload || typeof presignPayload !== "object") {
              logPlayerImgFailure(
                "after presign API: success true but data missing",
                "response.data.data is empty or not an object",
                {
                  ...imgLogCtx,
                  aid,
                  playerIdRoute: decode(pid),
                  httpStatus: externalResponse?.status,
                  apiBodyRedacted: redactPresignedInApiPayload(externalResponse?.data),
                }
              );
              throw new Error("Presign response missing data object");
            }

            const { presignedUrl, filename } = presignPayload;

            if (!presignedUrl || typeof presignedUrl !== "string") {
              logPlayerImgFailure(
                "after presign API: no presignedUrl",
                "presignedUrl missing or not a string (cannot PUT to S3)",
                {
                  ...imgLogCtx,
                  aid,
                  playerIdRoute: decode(pid),
                  serverFilename: filename,
                  presignedUrlSummary: summarizePresignedUrl(presignedUrl),
                  apiBodyRedacted: redactPresignedInApiPayload(externalResponse?.data),
                }
              );
              throw new Error("Presign response missing presignedUrl");
            }

            logPlayerImgUpload("presign_api_success", {
              requestedFilename: originalFileName,
              serverFilename: filename,
              presignedUrlSummary: summarizePresignedUrl(presignedUrl),
            });

            let blob;
            try {
              const cropRes = await fetch(croppedImage);
              if (!cropRes.ok) {
                logPlayerImgFailure(
                  "crop image: fetch(croppedImage) HTTP not ok",
                  `HTTP ${cropRes.status} ${cropRes.statusText}`,
                  {
                    ...imgLogCtx,
                    aid,
                    playerIdRoute: decode(pid),
                    cropSource: getCroppedImageSourceInfo(croppedImage),
                  }
                );
                throw new Error(
                  `Crop fetch failed: ${cropRes.status} ${cropRes.statusText}`
                );
              }
              blob = await cropRes.blob();
            } catch (blobErr) {
              logPlayerImgFailure(
                "crop image: data/blob conversion",
                blobErr?.message || String(blobErr),
                {
                  ...imgLogCtx,
                  aid,
                  playerIdRoute: decode(pid),
                  name: blobErr?.name,
                  cropSource: getCroppedImageSourceInfo(croppedImage),
                }
              );
              throw blobErr;
            }

            logPlayerImgUpload("blob_ready_for_s3", {
              blobSizeBytes: blob.size,
              blobType: blob.type || "(empty)",
            });

            const uploadResponse = await fetch(presignedUrl, {
              method: "PUT",
              headers: {
                "Content-Type": blob.type,
                "x-amz-acl": "public-read",
              },
              body: blob,
            });

            const s3Etag = uploadResponse.headers.get("etag");
            logPlayerImgUpload("s3_put_finished", {
              ok: uploadResponse.ok,
              status: uploadResponse.status,
              statusText: uploadResponse.statusText,
              etag: s3Etag,
            });

            if (!uploadResponse.ok) {
              const errorText = await uploadResponse.text();
              logPlayerImgUpload("s3_put_failed", {
                status: uploadResponse.status,
                statusText: uploadResponse.statusText,
                bodyPreview: errorText?.slice?.(0, 500) ?? String(errorText),
              });
              logPlayerImgFailure(
                "S3 PUT (presigned URL)",
                `S3 returned not OK: ${uploadResponse.status} ${uploadResponse.statusText}`,
                {
                  ...imgLogCtx,
                  aid,
                  playerIdRoute: decode(pid),
                  httpStatus: uploadResponse.status,
                  statusText: uploadResponse.statusText,
                  s3ErrorBodyPreview:
                    errorText?.slice?.(0, 500) ?? String(errorText),
                  blobSizeBytes: blob.size,
                  blobType: blob.type,
                  presignedHost: summarizePresignedUrl(presignedUrl).host,
                }
              );
              throw new Error("Failed to upload file to S3: " + errorText);
            }

            values["img"] = filename;
            logPlayerImgUpload("presign_flow_complete", {
              serverFilename: filename,
            });
          } else {
            const apiData = externalResponse?.data;
            const serverMsg = pickApiMessage(apiData);
            logPlayerImgUpload("presign_api_rejected", {
              httpStatus: externalResponse?.status,
              apiSuccessField: apiData?.success,
              serverMsg,
              apiBodyRedacted: redactPresignedInApiPayload(apiData),
            });
            logPlayerImgFailure(
              "getSignedUrl API",
              serverMsg ||
                "success was not true — presigned URL not issued (check serverMsg / apiBodyRedacted)",
              {
                ...imgLogCtx,
                aid,
                playerIdRoute: decode(pid),
                requestedFilename: filename,
                httpStatus: externalResponse?.status,
                apiSuccess: apiData?.success,
                serverMsg,
                apiBodyRedacted: redactPresignedInApiPayload(apiData),
              }
            );
            toast.error("External upload failed", { theme: "colored" });
            toast.dismiss(toastContainerId);
            setDisabled(false);
            return;
          }
        } catch (error) {
          logPlayerImgUpload("presign_flow_error", {
            name: error?.name,
            message: error?.message,
          });
          logPlayerImgFailure(
            "presign flow (network / axios / S3 / crop)",
            error?.message || String(error),
            {
              ...imgLogCtx,
              aid,
              playerIdRoute: decode(pid),
              requestedFilename: filename,
              errorName: error?.name,
              // axios: error.response exists when server returns 4xx/5xx
              axiosHttpStatus: error?.response?.status,
              axiosStatusText: error?.response?.statusText,
              axiosDataPreview:
                error?.response?.data != null
                  ? (typeof error.response.data === "string"
                      ? error.response.data.slice(0, 400)
                      : JSON.stringify(error.response.data).slice(0, 400))
                  : undefined,
            }
          );
          toast.error("External upload failed", { theme: "colored" });
          toast.dismiss(toastContainerId);
          setDisabled(false);
          return;
        }
      } else {
        logPlayerImgUpload("direct_upload_path_no_presign", {
          logContext: "Editplayers",
          aid,
          playerIdRoute: decode(pid),
          playerIdForm: values.pid,
          noPresignImg,
          cropSource: getCroppedImageSourceInfo(croppedImage),
          note: "image sent as logo_pic to editPlayer, no S3 presign",
        });
        values["logo_pic"] = croppedImage;
      }
    }

    DataService.editPlayer(values, hdr)
      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);

        if (response.success === true) {
          toast.success(response.msg, {
            theme: "dark",
            position: "bottom-center",
          });

          const db = getDatabase();
          set(ref(db, "map/info/" + aid), {
            type: "4",
            upd: "2",
            id: decode(pid),
            detail: {
              age: values.age,
              base: values.base,
              catid: values.catid ? values.catid : "",
              fname: values.fname,
              icons: values.icons,
              detail: values.detail,
              isnonplay: values.isnonplay,
              isowner: values.isowner,
              player_sold_to_team: values.player_sold_to_team,
              points: values.points,
              jrnm: values.jrno,
              img: response.data.detail.img,
              mob: values.mob,
              ownertag: values.ownertag,
              cus_tag: values.cus_tag,
              pcode: values.pcode,
              pname: values.pname,
              spcf1: values.spcf1,
              spcf2: values.spcf2,
              spcf3: values.spcf3,
              trouser: values.trouser,
              tshirt: values.tshirt,
            },
            tkn: updtoken,
          });
          history.push(BASE_PATH + "auction-players", { state: { fromEdit: true } });

          if (getpageData != 0) {
            const updateitem = getpageData.responsedata.list.filter(
              (ele, ind) => {
                if (ele.pid == values.pid) {
                  ele.pcode = values.pcode;
                  ele.mob = values.mob;
                  ele.pname = values.pname;
                  ele.fname = values.fname;
                  ele.ownertag = defaultIsOwner ? values.ownertag : "";
                  ele.isowner = defaultIsOwner ? values.isowner : "";
                  ele.age = values.age;
                  ele.cus_tag = values.cus_tag;
                  ele.tshirt = values.tshirt;
                  ele.trouser = values.trouser;
                  ele.detail = values.detail;
                  ele.spcf1 = values.spcf1;
                  ele.spcf2 = values.spcf2;
                  ele.spcf3 = values.spcf3;
                  ele.catid = values.catid;
                  ele.player_sold_to_team = values.player_sold_to_team;
                  ele.points = values.points;

                  if (
                    response.data.img != "" &&
                    response.data.img != null &&
                    response.data.img != "null"
                  ) {
                    ele.img = response.data.img;
                  }

                  ele.wkeep = values.wkeep;

                  if (values.isbatting != "" && values.batsmantyp != "") {
                    if (values.batsmantyp == "Other") {
                      ele.righthand = values.batsmantyp_other;
                    } else {
                      ele.righthand = values.batsmantyp;
                    }
                  } else {
                    ele.righthand = "";
                  }

                  if (values.isbowler != "" && values.bowling_type != "") {
                    if (values.bowling_type == "Other") {
                      ele.boller = values.other_bowling;
                    } else {
                      ele.boller = values.bowling_type;
                    }
                  } else {
                    ele.boller = "";
                  }
                }
                return ele;
              }
            );

            let responsedata = {
              responsedata: {
                path: getpageData.responsedata.path,
                aid: aid,
                list: updateitem,
              },
            };
            dispatch(playerlistData(responsedata));
          }
        } else {
          toast.error(response.msg, { theme: "colored" });
        }

        setDisabled(false);
        setIsUploading(false);
      })
      .catch(() => {
        toast.dismiss(toastContainerId);
        toast.error("Not valid Server Error", { theme: "colored" });
        setDisabled(false);
        setIsUploading(false);
      });
  };


  const firechange = (datasnap) => {
    if (datasnap.type == "1" && datasnap.upd == "3") {
      if (getaucpageData != 0) {
        const updateitem = getaucpageData.responsedata.list.filter(
          (ele) => ele.aid != datasnap.id
        );

        let responsedata = {
          responsedata: {
            path: getaucpageData.responsedata.path,
            cid: cid,
            list: updateitem,
          },
        };
        dispatch(actlistData(responsedata));
      }
      history.push(BASE_PATH + "my-auction");
    }
  };

  useEffect(() => {
    if (match?.ownertag || match?.cus_tag) {
      if (match.ownertag === "7" && match.cus_tag) {
        settagid("other");
        setCustomTag(match.cus_tag);
      } else {
        settagid(match.ownertag || "0");
        setCustomTag("");
      }
    }
    // // console.log('useEffect')
    // // console.log(getpageData)
    // // console.log(getpageData?.responsedata?.list)
    // // console.log(decode(pid))
    window.scrollTo(0, 0);

    fetchcatData(0);

    // Log detail API response (aucmoredetail) for debugging
    if (aucmoredetail) {
      console.log("aucmoredetail++++++++++++++++++++++++++", aucmoredetail);
    }
    // Check if payment QR data is available in aucmoredetail
    if (aucmoredetail && aucmoredetail.pyqr) {
      setPyqr(aucmoredetail.pyqr);
    }

    const updateitem = getpageData?.responsedata?.list?.filter((ele, ind) => {
      if (ele.pid == decode(pid)) {
        // // console.log('ele')
        // // console.log(ele)
        setBatting(ele.spcf1);

        //  // // console.log(ele)
        setValue("pcode", ele.pcode);
        setValue("mob", ele.mob);
        setValue("pname", ele.pname);
        setValue("fname", ele.fname);
        //setValue("dob", ele.dob);
        setValue("age", ele.age);
        setValue("plst", ele.plst);
        setValue("tshirt", ele.tshirt);
        setValue("trouser", ele.trouser);
        setValue("detail", ele.detail);
        setValue("spcf1", ele.spcf1);
        setValue("spcf2", ele.spcf2);
        setValue("spcf3", ele.spcf3);
        setBowling(ele.spcf2);
        setsp3(ele.spcf3);
        setValue("isnonplay", ele.isnonplay);
        const teamId = ele.tmid != null && ele.tmid !== "" && String(ele.tmid).trim() !== "" ? String(ele.tmid) : (ele.isowner != null && ele.isowner !== "" ? String(ele.isowner) : "");
        setValue("isowner", teamId);
        setIsOwner(teamId);
        setValue("cus_tag", ele.cus_tag);
        setValue("jrno", ele.jrno);
        setValue("jrnm", ele.jrnm);
        setValue("base", ele.base);
        if (catData != "") {
          setValue("catid", ele.catid);
        }


        // if (aucmoredetail && aucmoredetail.show) {


        //   if (isShow(aucmoredetail.show.sp1?.show)) {
        //     const spcf1Value = ele.spcf1;

        //     // CHECK CUSTOM OPTIONS FIRST
        //     let options = [];

        //     if (aucmoredetail.show.sp1.opt == null || aucmoredetail.show.sp1.opt.trim() === "") {
        //       // ---- DEFAULT OPTIONS ----
        //       options = sp1opt;   // ⭐ yahi missing tha
        //     } else {
        //       // ---- CUSTOM OPTIONS ----
        //       options = aucmoredetail.show.sp1.opt.split(",").map(o => o.trim());
        //     }

        //     // Selected value exists in options
        //     if (spcf1Value && options.includes(spcf1Value)) {
        //       setSp1Value(spcf1Value);
        //       setValue("spcf1", spcf1Value);
        //     }
        //     else {
        //       // Default fallback
        //       const defaultOption =
        //         options.find(o => o === aucmoredetail.show.sp1.default) ||
        //         options[0] ||
        //         "";

        //       setSp1Value(defaultOption);
        //       setValue("spcf1", defaultOption);
        //     }
        //   }



        // if (isShow(aucmoredetail.show.sp2?.show)) {
        //   const selected = ele.spcf2;

        //   let options = [];


        //   if (!aucmoredetail.show.sp2.opt || aucmoredetail.show.sp2.opt.trim() === "") {
        //     options = sp2opt;
        //   }

        //   else {
        //     options = aucmoredetail.show.sp2.opt
        //       .split(",")
        //       .map(o => o.trim())
        //       .filter(Boolean);
        //   }

        //   // SELECTED EXISTS IN OPTIONS
        //   if (selected && options.includes(selected)) {
        //     setSp2Value(selected);
        //     setValue("spcf2", selected);
        //   }
        //   // SELECTED DOES NOT EXIST → FALLBACK
        //   else {
        //     // Default fallback
        //     const defaultOption =
        //       options.find(o => o === aucmoredetail.show.sp2.default) ||
        //       options[0] ||
        //       "";

        //     setSp2Value(defaultOption);
        //     setValue("spcf2", defaultOption);
        //   }
        // }




        //   if (isShow(aucmoredetail.show.sp3?.show)) {
        //     const spcf3Value = ele.spcf3;

        //     let options = [];

        //     // DEFAULT OPTIONS
        //     if (!aucmoredetail.show.sp3.opt || aucmoredetail.show.sp3.opt.trim() === "") {
        //       options = sp3opt;  // <<==== IMPORTANT
        //     }
        //     // CUSTOM OPTIONS
        //     else {
        //       options = aucmoredetail.show.sp3.opt
        //         .split(",")
        //         .map(o => o.trim())
        //         .filter(Boolean);
        //     }

        //     if (spcf3Value && options.includes(spcf3Value)) {
        //       setSp3Value(spcf3Value);
        //       setValue("spcf3", spcf3Value);
        //     } else {
        //       const defaultOption =
        //         options.find(o => o === aucmoredetail.show.sp3.default) ||
        //         options[0] ||
        //         "";

        //       setSp3Value(defaultOption);
        //       setValue("spcf3", defaultOption);
        //     }
        //   }

        // }


        setcatid(ele.catid);
        if (ele.ownertag != "" && ele.ownertag != null && ele.ownertag != "0") {
          settagid(ele.ownertag);
        }
        if (ele.cus_tag != "" && ele.cus_tag != null) {
          setCustomTag(ele.cus_tag); // sirf value set hogi
        }

        //  // // console.log('show me ele')
        //  // // console.log(ele)
        //  // // console.log(ele.runwkt)
        if (ele.runwkt !== null && ele.runwkt !== "") {
          try {
            var runwktData = JSON.parse(ele.runwkt);

            // Check if runwktData is an array, if not convert it
            if (!Array.isArray(runwktData)) {
              if (typeof runwktData === 'object' && runwktData !== null) {
                // Convert object to array
                runwktData = Object.values(runwktData).filter(item => item && item.N);
              } else {
                // If it's not an object or array, set to empty array
                runwktData = [];
              }
            }

            // Only proceed if we have a valid array
            if (Array.isArray(runwktData) && runwktData.length > 0) {
              runwktData.forEach((rwItem, index) => {
                runwktData[index].o = ""; // Mark other fields as not selected
                runwktData[index].t = "0";
                // Check if runwkt.N matches extra.l and update extra.o accordingly
                extra.forEach((extraItem) => {
                  if (rwItem.N === extraItem.l) {
                    runwktData[index].o = extraItem.o; // Set the value from runwkt.V to extra.o
                    runwktData[index].t = extraItem.t;
                  }
                });
              });
              console.log(runwktData);

              setRunwkt(runwktData);

              // If runwkt has entries, use only those fields and ignore extra
              // Set values for runwkt fields as extra_0, extra_1, extra_2, etc.
              runwktData.forEach((rwItem, index) => {
                var vvl = rwItem.V;
                if (rwItem.t == "3" && typeof rwItem.V === "string") {
                  vvl = rwItem.V.split(",");
                } else {
                  vvl = rwItem.V;
                }

                setValue("extra_" + index, vvl);

              });
            } else {
              // If no valid data, set empty array
              setRunwkt([]);
            }
          } catch (error) {
            console.error("Error parsing runwkt data:", error);
            setRunwkt([]);
          }
        }
        setDefaultIsOwner((ele.tmid != null && ele.tmid !== "" && Number(ele.tmid) >= 1) || (ele.isowner != null && Number(ele.isowner) >= 1) ? true : false);
        setIsNonPlayer(ele.isnonplay == 1 ? true : false);
        // tmid aati hai = player sold to that team; is basis pe checkbox tick
        const hasTmid = ele.tmid != null && ele.tmid !== "" && String(ele.tmid).trim() !== "" && Number(ele.tmid) !== 0;
        setPlayerSoldToTeam(!!hasTmid);
        const pointsVal = ele.points != null && ele.points !== "" ? String(ele.points) : (ele.point != null && ele.point !== "" ? String(ele.point) : "0");
        setPoints(pointsVal);
        // setBowling(ele.spcf2);
        // setsp3(ele.spcf3);

        if (!checklist.includes(ele.spcf1)) {
          setschecklist([
            "All Rounder",
            "Batting All Rounder",
            "All Rounder Wicketkeeper",
            "Batsman",
            "Wicket Keeper",
            "Batter",
            "Other",
            "",
          ]);
        }

        if (auctype == 0) {
          var sdf = 0;
          if (aucmoredetail.show.sp2.opt != null && aucmoredetail.show.sp2.opt.trim() !== "") {
            const options = aucmoredetail.show.sp2.opt.split(",").map(o => o.trim());
            if (options.includes(ele.spcf2)) {
              setValue("spcf2", ele.spcf2);
              sdf = 1;
            }
          }
          if (aucmoredetail.show.sp1.opt == null || aucmoredetail.show.sp1.opt.trim() == "") {


            if (!sp1opt.includes(ele.spcf1)) {
              setValue("spcf1", "Other");

              setOtherBatting(true);
              setother(ele.spcf1);
              //  // // console.log(ele.spcf1)
            }
          } else {
            const options = aucmoredetail.show.sp1.opt.split(",").map(o => o.trim());
            if (!options.includes(ele.spcf1)) {
              setValue("spcf1", "Other");

              setOtherBatting(true);
              setother(ele.spcf1);
            }
          }
          if (aucmoredetail.show.sp2.opt == null || aucmoredetail.show.sp2.opt.trim() == "") {
            if (ele.spcf1 == "Bowler" || ele.spcf1 == "Bowling All Rounder") {
              if (!sp3opt.includes(ele.spcf2)) {
                setBowling("Other");
                setValue("spcf2", "Other");
                setOtherBowling(true);
                //  // // console.log(ele.spcf2)

                setother2(ele.spcf2);
              }
              if (!sp2opt.includes(ele.spcf3)) {
                setsp3("Other");
                setother3(ele.spcf3);
                setValue("spcf3", "Other");
                setOthersp3(true);
                //  // // console.log(ele.spcf2)

                // setsp3(ele.spcf3)
              }
            } else if (sdf == 0) {
              if (!sp2opt.includes(ele.spcf2)) {
                setBowling("Other");
                //  // // console.log("sp2 other")
                setValue("spcf2", "Other");
                setOtherBowling(true);
                //  // // console.log(ele.spcf2)

                setother2(ele.spcf2);
              }
              //  // // console.log(ele.spcf3)

              if (!sp3opt.includes(ele.spcf3)) {
                // set
                setsp3("Other");
                setother3(ele.spcf3);
                //  // // console.log("sp2 other")
                setValue("spcf3", "Other");
                setOthersp3(true);
                //  // // console.log(ele.spcf2)
              }
            }
          } else {
            const options = aucmoredetail.show.sp2.opt.split(",").map(o => o.trim());
            if (!options.includes(ele.spcf2)) {
              setBowling("Other");
              //  // // console.log("sp2 other")
              setValue("spcf2", "Other");
              setOtherBowling(true);
              //  // // console.log(ele.spcf2)

              setother2(ele.spcf2);
            }
          }

        }
        if (ele.icons !== "" && ele.icons !== null) {
          // // console.log('ele.icons')
          // // console.log(ele.icons)
          var styles = ele?.icons?.split(",");
          styles?.forEach((ele) => {
            if (ele == "ball.png") {
              //  // // console.log("trihh")
              setisbol(true);
            } else if (ele == "bat.png") {
              //  // // console.log("trihh22")

              setisbat(true);
            } else {
              //  // // console.log("trihh33")

              setiswkeep(true);
            }
          });
        }
        // if(ele.img)

        if (ele.img != "" && ele.img != null) {
          setdefimg(getPlayerImgUrl(getpageData.responsedata.path, ele.img));
        }
        // $(".crop-default img").attr(
        //   "src",
        //   ele.img
        //     ? `${getpageData.responsedata.path}${ele.img}`
        //     : playerdefaultLogo
        // );
      }
    });

    $(".crop-default").click(function () {
      $("#crop-pic").click();
    });
  }, [Demo]);


  useEffect(() => {
    if (upddata !== null) {
      if (upddata !== isfirsttime) {
        firechange(upddata);
        if (upddata.upd == "4") {
          dispatch(setisfirsttime(upddata));
        }
      }
    }
  }, [upddata]);

  useEffect(() => {
    const isFirstMount = localStorage.getItem("isFirstMount");
    //  // // console.log('isFirstMount')
    //  // // console.log(isFirstMount)
    if (!isFirstMount) {
      localStorage.setItem("isFirstMount", false);
    } else {
      localStorage.removeItem("isFirstMount");
      history.push("/auction-detail");
    }
  }, [history]);
  // //  // // console.log(isOwner, "isOwner2");
  // //  // // console.log(defaultIsOwner, "default");
  var batstyle = {
    backgroundColor: "white",
  };
  var bolstyle = {
    backgroundColor: "white",
  };
  var wkeepstyle = {
    backgroundColor: "white",
  };
  if (isbat == true) {
    batstyle = {
      // backgroundColor: 'black',
      // color: 'white',
      opacity: 1,
      border: "3px solid #3e71a3",
    };
  }
  if (isbol == true) {
    bolstyle = {
      // backgroundColor: 'black',
      // color: 'white',
      opacity: 1,
      border: "3px solid #3e71a3",
    };
  }
  if (iswkeep == true) {
    wkeepstyle = {
      // backgroundColor: 'black',
      // color: 'white',
      opacity: 1,
      border: "3px solid #3e71a3",
    };
  }
  return (
    <>
      <div>
        <Navigationtitle data={match} />

        <div
          id="top-categories"
          className="top-cat-area default-padding bottom-less"
        >
          <div className="container-fluid">
            <div className="row">
              <div id="contact-us" className="reg-area">
                <div className="container-fluid">
                  <div className="row myclass1">
                    <div className="reg-items">
                      <div className="col-md-5  reg-form">
                        <form
                          onSubmit={handleSubmit(onSubmit)}
                          action=""
                          autoComplete="off"
                          encType="multipart/form-data"
                        >
                          <input
                            type="hidden"
                            value={decode(pid)}
                            {...register("pid")}
                          />
                          <div className="row">
                            <div className="col-md-12">
                              <div className="col-md-6">
                                <div className="form-group text-box-margin mobile-marginbt">
                                  <div className="col-md-4">
                                    {" "}
                                    <label
                                      htmlFor="crop-pic"
                                      className="addpl-label"
                                    >
                                      {" "}
                                      Profile Pic{/*logo*/}{" "}
                                    </label>
                                  </div>
                                  <div className="col-md-8">
                                    {" "}
                                    <div style={{ clear: "both" }}></div>
                                    <ImageCropper2
                                      croppedImage={croppedImage}
                                      defaultImage={defimg}
                                      // bydefault={playerdefaultLogo}
                                      setCroppedImage={setCroppedImage}
                                      setOriginalFileName={setOriginalFileName}
                                    // setdefimg={setdefimg}
                                    />
                                    {/* {localStorage.getItem("crp_typ") == 0 ? (
                                      <ImageCropper2
                                        croppedImage={croppedImage}
                                        defaultImage={defimg}
                                        // bydefault={playerdefaultLogo}
                                        setCroppedImage={setCroppedImage}
                                        setOriginalFileName={
                                          setOriginalFileName
                                        }
                                        // setdefimg={setdefimg}
                                      />
                                    ) : (
                                      <ImageCropper1
                                        croppedImage={croppedImage}
                                        // bydefault={playerdefaultLogo}

                                        defaultimage={defimg}
                                        setCroppedImage={setCroppedImage}
                                        setOriginalFileName={
                                          setOriginalFileName
                                        }
                                        // setdefimg={setdefimg}
                                      />
                                    )} */}
                                    {/* {playimg != null ? (
                                      <Image
                                        className="user-pic"
                                        fallback={
                                          <Shimmer width={265} height={265} />
                                        }
                                        src={playimg}
                                      ></Image>
                                    ) : (
                                      <></>
                                    )} */}
                                  </div>
                                </div>
                              </div>
                              <div className="col-xs-12 col-md-6 ">
                                {/* <div className="col-md-12"> */}
                                <div className="form-group text-box-margin addpl-marginbt">
                                  <div className="col-md-4">
                                    <label
                                      htmlFor="pcode"
                                      className="addpl-label"
                                    >
                                      {" "}
                                      Form No *
                                    </label>
                                  </div>
                                  <div className="col-md-8">
                                    {" "}
                                    <input
                                      className="form-control addpl-input-control"
                                      placeholder="Enter Form Number"
                                      type="text"
                                      {...register("pcode", {
                                        required: true,
                                        required: "required field.",
                                      })}
                                      id="pcode"
                                    />
                                    {errors.pcode && (
                                      <p className="text-error">
                                        {errors.pcode.message}
                                      </p>
                                    )}
                                  </div>
                                  {/* </div> */}
                                </div>
                                {/* <div className="col-md-12 margin-top-14px"> */}

                                {/* <div className="form-group text-box-margin">
                                  <div className="col-md-4  margin-top-14px">
                                    <label htmlFor="date">
                                      {" "}
                                      Date of Birth{" "}
                                    </label>
                                  </div>
                                  <div className="col-md-8  margin-top-14px">
                                    <input
                                      className="form-control"
                                      type="date"
                                      id="date"
                                      {...register("dob", {})}
                                    />
                                  </div>
                                </div> */}
                                <div className="form-group text-box-margin addpl-marginbt">
                                  <div className="col-md-4 margin-top-14px margintop-0px">
                                    <label
                                      htmlFor="age"
                                      className="addpl-label"
                                    >
                                      {" "}
                                      Age{" "}
                                    </label>
                                  </div>
                                  <div className="col-md-8  margin-top-14px margintop-0px">
                                    <input
                                      className="form-control addpl-input-control"
                                      type="number"
                                      id="age"
                                      {...register("age", {})}
                                    />
                                  </div>
                                </div>
                                {/* </div> */}
                              </div>
                            </div>

                            <div className="col-md-12 margin-top-14px margintop-0px">
                              <div className="col-md-6">
                                <div className="form-group text-box-margin addpl-marginbt">
                                  <div className="col-md-4">
                                    <label
                                      htmlFor="pname"
                                      className="addpl-label"
                                    >
                                      {" "}
                                      Name *{" "}
                                    </label>
                                  </div>
                                  <div className="col-md-8">
                                    {" "}
                                    <input
                                      className="form-control addpl-input-control gg"
                                      placeholder="Enter Name"
                                      type="text"
                                      id="pname"
                                      // style={{width:"103%"}}
                                      {...register("pname", {
                                        required: true,
                                        required: "required field.",
                                      })}
                                    />
                                    {errors.pname && (
                                      <p className="text-error">
                                        {errors.pname.message}
                                      </p>
                                    )}
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="form-group text-box-margin addpl-marginbt">
                                  <div className="col-md-4">
                                    <label
                                      htmlFor="fname"
                                      className="addpl-label"
                                    >
                                      {" "}
                                      Father Name{" "}
                                    </label>
                                  </div>
                                  <div className="col-md-8">
                                    {" "}
                                    <input
                                      className="form-control addpl-input-control"
                                      placeholder="Enter Father Name"
                                      id="fname"
                                      type="text"
                                      {...register("fname", {})}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-12 margin-top-14px margintop-0px">
                              <div className="col-md-12">
                                <div className="form-group text-box-margin">
                                  <div className="col-md-2">
                                    <label
                                      htmlFor="mob"
                                      className="addpl-label"
                                    >
                                      {" "}
                                      Mobile No{" "}
                                    </label>
                                  </div>
                                  <div className="col-md-4 margin-left-6px mobile-marginbt">
                                    {" "}
                                    <input
                                      className="form-control addpl-input-control"
                                      placeholder="Mobile number"
                                      id="mob"
                                      type="text"
                                      {...register("mob", {})}
                                    />
                                  </div>
                                  {catData != "" && (
                                    <div className="col-md-6">
                                      <div className="form-group text-box-margin addpl-marginbt">
                                        <div className="col-md-4 addpl-padding">
                                          <label
                                            htmlFor="trouser"
                                            className="addpl-label"
                                          >
                                            {" "}
                                            Select Category{" "}
                                          </label>
                                        </div>
                                        <div className="col-md-8 addpl-padding">
                                          <select
                                            className="form-control addpl-select-control zxc"
                                            type="text"
                                            {...register("catid")}
                                            value={catid}
                                            onChange={(e) => {
                                              setcatid(e.target.value);
                                            }}
                                          >
                                            <option value="" selected>
                                              Select category
                                            </option>
                                            {catData?.map((ct) => (
                                              <option
                                                value={ct.cid}
                                                key={ct.cid}
                                              >
                                                {ct.cname}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="col-md-12 margin-top-14px margintop-0px">
                              <div className="col-md-12">
                                <div className="form-group text-box-margin">

                                  {/* TAG / OWNER LABEL */}
                                  <div className="isowner-div">
                                    <div className="col-xs-8 col-sm-3 col-md-2 margin-top-14px margintop-0px">
                                      <label htmlFor="isowner" className="addpl-label">Tag/Owner</label>
                                    </div>
                                  </div>

                                  {/* SELECT TAG */}
                                  <div className="col-xs-12 col-sm-12 col-md-4 margin-top-14px-isowner hyyy">
                                    <select
                                      className="form-control addpl-select-control"
                                      {...register("ownertag")}
                                      value={tagid}
                                      onChange={(e) => settagid(e.target.value)}
                                    >
                                      <option value="0">Select tag</option>
                                      <option value="1">Owner</option>
                                      <option value="2">Co-owner</option>
                                      <option value="3">Captain</option>
                                      <option value="6">Vice Captain</option>
                                      <option value="4">Icon</option>
                                      <option value="5">Retain</option>
                                      <option value="7">Other</option>
                                    </select>
                                  </div>

                                  {/* SELECT TEAM */}
                                  <div className="col-xs-12 col-sm-12 col-md-4 margin-top-14px-isowner">
                                    <select
                                      className="form-control addpl-select-control"
                                      id="isowner"
                                      value={isOwner > 1 ? isOwner : ""}
                                      onChange={(e) => setIsOwner(e.target.value)}
                                      disabled={tagid === "0" || !tagid}
                                    >
                                      <option value="">Select Team</option>
                                      {getTeamList?.responsedata?.list?.map((team) => (
                                        <option value={team.tid} key={team.tid}>{team.name}</option>
                                      ))}
                                    </select>
                                  </div>

                                  {/* CUSTOM TAG */}
                                  <div className="col-xs-12 col-sm-12 col-md-4 margin-top-14px-isowner mt-4 hig">
                                    <input
                                      type="text"
                                      className="form-control addpl-select-control abc"
                                      placeholder="Custom tag"
                                      value={customTag}
                                      onChange={(e) => setCustomTag(e.target.value)}
                                      disabled={tagid === "0" || !tagid}
                                    />
                                  </div>


                                  {/* Is Non Playing Owner? + Player sold to team in one row; Points only when Player sold to team is checked */}
                                  {tagid !== "0" && tagid !== "" && (
                                    <>
                                      <div className="col-xs-12 margin-top-14px-isowner" style={{ display: "flex", flexDirection: "row", alignItems: "center", flexWrap: "nowrap", gap: "16px", width: "42%", minWidth: "320px" }}>
                                        <div className="nonplowner-block" style={{ flex: "0 0 auto", minWidth: "140px" }}>
                                          <label htmlFor="isnonplay" className="addpl-label vbn">Is Non Playing Owner?</label>
                                          <input
                                            className="form-control nonplowner-div"
                                            type="checkbox"
                                            id="isnonplay"
                                            checked={isNonPlayer}
                                            onClick={(e) => {
                                              const checked = e.target.checked;
                                              setIsNonPlayer(checked);
                                              // When Is Non Playing Owner? checked: only hide sold/points UI, do not zero their values
                                            }}
                                          />
                                        </div>
                                        {!isNonPlayer && Number(isOwner) > 0 && (
                                          <div className="nonplowner-block" style={{ flex: "0 0 auto", minWidth: "140px" }}>
                                            <label htmlFor="playerSoldToTeam" className="addpl-label vbn">Retained To Team</label>
                                            <input
                                              className="form-control nonplowner-div"
                                              type="checkbox"
                                              id="playerSoldToTeam"
                                              checked={playerSoldToTeam}
                                              onChange={(e) => setPlayerSoldToTeam(e.target.checked)}
                                            />
                                          </div>
                                        )}
                                      </div>
                                      {!isNonPlayer && playerSoldToTeam && Number(isOwner) > 0 && (
                                        <>
                                          <div className="col-md-12 margin-top-14px margintop-0px">
                                            <div className="col-md-2">
                                              <label htmlFor="points" className="addpl-label">Points</label>
                                            </div>
                                            <div className="col-md-4 margin-left-6px mobile-marginbt">
                                              <input
                                                className="form-control addpl-input-control"
                                                type="text"
                                                inputMode="numeric"
                                                id="points"
                                                value={points}
                                                onChange={(e) => {
                                                  const v = e.target.value;
                                                  if (v === "" || /^\d+$/.test(v)) setPoints(v);
                                                }}
                                                placeholder="Enter points"
                                              />
                                            </div>
                                          </div>
                                        </>
                                      )}
                                    </>
                                  )}

                                </div>
                              </div>
                            </div>

                            {auctype == 0 && (
                              <div className="col-md-12">
                                <div className="col-md-12">
                                  <div className="col-md-2 margin-top-14px margintop-0px">
                                    <label htmlFor="" className="addpl-label">
                                      {" "}
                                      Playing Style
                                    </label>
                                  </div>
                                  <div className="col-md-8 mobile-marginbt">
                                    <div
                                      className={`roleclass form-group text-box-margin ${isTabletOrMobile || isPortrait
                                        ? "row"
                                        : null
                                        }`}
                                    >
                                      <div className="">
                                        <img
                                          onClick={() => setisbat(!isbat)}
                                          src={bat}
                                          alt=""
                                          style={batstyle}
                                        />
                                      </div>
                                      <div className="">
                                        <img
                                          onClick={() => setisbol(!isbol)}
                                          src={ball}
                                          alt=""
                                          style={bolstyle}
                                        />
                                      </div>
                                      <div className="">
                                        <img
                                          onClick={() => setiswkeep(!iswkeep)}
                                          src={wkeeper}
                                          alt=""
                                          style={wkeepstyle}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            <div className="col-md-12 margin-top-14px margintop-0px">
                              {/* Dynamic Extra Fields */}
                              {runwkt && runwkt.length > 0 ? (
                                // Case 1: runwkt exists → use only those fields (new format)
                                runwkt.map((item, index) => {
                                  const fieldName = `extra_${index}`;
                                  if (item.o) {
                                    var dynamicoptions =
                                      item.o.split(",");
                                  }
                                  return (
                                    <div className="col-md-6 m-top-2" key={index}>
                                      <div className="form-group text-box-margin addpl-marginbt">
                                        <div className="col-md-4">
                                          <label title={item.V}>{item.N}</label>
                                        </div>
                                        <div className="col-md-8" title={item.o}>
                                          {item.t == "3" && item.o && (
                                            <div className="checkbox-options-wrapper space-y-2">
                                              {dynamicoptions && dynamicoptions.length > 0 ? (
                                                dynamicoptions.map((opt, optIndex) => {
                                                  // Hamesha form ka current value lo — yeh real-time update hota rahega
                                                  const currentSelected = watch(`extra_${index}`) || [];

                                                  // Check karo ki current option selected hai ya nahi
                                                  const isChecked = Array.isArray(currentSelected)
                                                    ? currentSelected.includes(opt.trim())
                                                    : false;

                                                  return (
                                                    <label
                                                      key={optIndex}
                                                      htmlFor={`extra_${index}_opt_${optIndex}`}
                                                      style={{
                                                        gap: "10px",
                                                        alignItems: 'center',
                                                        height: "20px"
                                                      }}
                                                      className="flex items-center space-x-2 cursor-pointer"
                                                    >
                                                      <input
                                                        type="checkbox"
                                                        id={`extra_${index}_opt_${optIndex}`}
                                                        checked={isChecked}
                                                        className="h-4 w-4"
                                                        onChange={(e) => {
                                                          const checked = e.target.checked;
                                                          const prev = watch(`extra_${index}`) || [];

                                                          let updated;
                                                          if (checked) {
                                                            updated = [...prev, opt.trim()];
                                                          } else {
                                                            updated = prev.filter((v) => v !== opt.trim());
                                                          }

                                                          setValue(`extra_${index}`, updated, { shouldValidate: true });
                                                        }}
                                                      />
                                                      <span className="text-sm font-medium text-gray-700">{opt}</span>
                                                    </label>
                                                  );
                                                })
                                              ) : (
                                                <p className="text-xs text-gray-500">No options configured</p>
                                              )}
                                            </div>
                                          )}
                                          {item.t == "2" && dynamicoptions && dynamicoptions.length > 0 && (
                                            <div>
                                              <select
                                                className="form-control addpl-select-control"
                                                {...register(fieldName, {
                                                  required: item.r === "1" ? `${item.l} is required` : false,
                                                })}
                                                value={valueWatch[fieldName] || ""}  // 👈 THIS FIXES YOUR ISSUE
                                                onChange={(e) => setValue(fieldName, e.target.value)} // 👈 required for controlled select
                                              >
                                                <option value="" disabled>
                                                  -- Select {item.l} --
                                                </option>
                                                {dynamicoptions.map((opt) => (
                                                  <option key={opt} value={opt}>
                                                    {opt}
                                                  </option>
                                                ))}
                                              </select>

                                              {errors[fieldName] && (
                                                <p className="text-error text-sm mt-1">
                                                  {errors[fieldName]?.message || "This field is required"}
                                                </p>
                                              )}
                                            </div>
                                          )}


                                          {item.t === "4" ? (

                                            valueWatch?.[`extra_${index}`] ? (

                                              <a
                                                href={BASE_FILE_PATH + valueWatch[`extra_${index}`]}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-blue-600 underline text-sm"
                                                style={{ color: "#2563eb" }}
                                              >
                                                {valueWatch[`extra_${index}`]}
                                              </a>
                                            ) : (
                                              <span className="text-gray-500 text-sm">No file uploaded</span>
                                            )
                                          ) : (
                                            // other input fields (unchanged)
                                            item.t !== "3" &&
                                            item.t !== "2" && (
                                              <input
                                                title={item.o}
                                                placeholder={item.N}
                                                className="form-control addpl-input-control"
                                                type="text"
                                                {...register(`extra_${index}`, { required: false })}
                                              // disabled={isEditPage}  // optional if needed
                                              />
                                            )
                                          )}

                                        </div>
                                      </div>
                                    </div>)
                                })
                              ) : extra && extra.length > 0 ? (
                                // Case 2: Use auction extra config
                                extra.map((item, index) => {
                                  console.log("----------------", item);

                                  const fieldName = `extra_${index}`;
                                  const savedValue = watch(fieldName); // Get current value (for checkboxes, it's array)

                                  // Parse options if t=2 or t=3
                                  const options = item.o ? item.o.split(",").map(o => o.trim()) : [];

                                  return (
                                    <div className="col-md-6 m-top-2" key={index}>
                                      <div className="form-group text-box-margin addpl-marginbt">
                                        <div className="col-md-4">
                                          <label>
                                            {item.l} {item.r === "1" && <span className="text-red-500">*</span>}
                                          </label>
                                        </div>
                                        <div className="col-md-8">
                                          {item.t === "0" && (
                                            <input
                                              type="text"
                                              placeholder={item.l}
                                              className="form-control addpl-input-control"
                                              {...register(fieldName, {
                                                required: item.r === "1" ? `${item.l} is required` : false,
                                              })}
                                            />
                                          )}

                                          {item.t === "1" && (
                                            <input
                                              type="number"
                                              placeholder={item.l}
                                              className="form-control addpl-input-control"
                                              {...register(fieldName, {
                                                required: item.r === "1" ? `${item.l} is required` : false,
                                              })}
                                            />
                                          )}
                                          {item.t === "2" && options.length > 0 && (
                                            <div>
                                              <select
                                                className="form-control addpl-select-control"
                                                {...register(fieldName, {
                                                  required: item.r === "1" ? `${item.l} is required` : false,
                                                })}
                                              >
                                                <option value="" disabled>
                                                  -- Select {item.l} --
                                                </option>
                                                {options.map((opt) => (
                                                  <option key={opt} value={opt}>
                                                    {opt}
                                                  </option>
                                                ))}
                                              </select>
                                              {errors[fieldName] && (
                                                <p className="text-error text-sm mt-1">
                                                  {errors[fieldName]?.message || "This field is required"}
                                                </p>
                                              )}
                                            </div>
                                          )}

                                          {item.t === "3" && options.length > 0 && (
                                            <div className="space-y-2">
                                              {options.map((opt) => {
                                                const isChecked = Array.isArray(savedValue)
                                                  ? savedValue.includes(opt)
                                                  : false;

                                                return (
                                                  <label
                                                    key={opt}
                                                    className="flex items-center gap-2 cursor-pointer text-sm"
                                                  >
                                                    <input
                                                      type="checkbox"
                                                      value={opt}
                                                      checked={isChecked}
                                                      onChange={(e) => {
                                                        const checked = e.target.checked;
                                                        const current = watch(fieldName) || [];

                                                        let updated;
                                                        if (checked) {
                                                          updated = [...current, opt];
                                                        } else {
                                                          updated = current.filter((v) => v !== opt);
                                                        }

                                                        setValue(fieldName, updated);
                                                      }}
                                                    />
                                                    <span>{opt}</span>
                                                  </label>
                                                );
                                              })}
                                            </div>
                                          )}

                                          {errors[fieldName] && (
                                            <p className="text-error text-sm mt-1">
                                              {errors[fieldName]?.message || "This field is required"}
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })
                              ) : null}
                            </div>
                            {aucmoredetail &&
                              aucmoredetail.show &&
                              aucmoredetail.show.sp1 &&
                              aucmoredetail.show.sp1.show == 1 && (
                                <div className="col-md-12 margin-top-14px margintop-0px">
                                  <div className="col-md-6">
                                    <div className="form-group text-box-margin addpl-marginbt">
                                      <div className="col-md-4">
                                        <label
                                          htmlFor="spcf1"
                                          className="addpl-label"
                                        >
                                          {" "}
                                          {aucmoredetail.show.sp1.label !== ""
                                            ? aucmoredetail.show.sp1.label
                                              .charAt(0)
                                              .toUpperCase() +
                                            aucmoredetail.show.sp1.label.slice(
                                              1
                                            )
                                            : "Specification 1"}
                                        </label>
                                      </div>
                                      {auctype != 0 ? (
                                        <div className="col-md-8">
                                          {" "}
                                          <input
                                            placeholder={
                                              aucmoredetail.show.sp1.label !==
                                                ""
                                                ? aucmoredetail.show.sp1.label
                                                  .charAt(0)
                                                  .toUpperCase() +
                                                aucmoredetail.show.sp1.label.slice(
                                                  1
                                                )
                                                : "Specification 1"
                                            }
                                            className="form-control addpl-select-control"
                                            type="text"
                                            {...register("spcf1", {})}
                                          />
                                        </div>
                                      ) : (
                                        <div className="col-md-6">
                                          {" "}
                                          <select
                                            className="form-control addpl-select-control"
                                            id="spcf1"
                                            type="text"
                                            {...register("spcf1")}
                                            onChange={(e) => {
                                              if (e.target.value === "Other") {
                                                setOtherBatting(true);
                                              } else {
                                                setOtherBatting(false);
                                              }

                                              if (
                                                !checklist.includes(
                                                  e.target.value
                                                )
                                              ) {
                                                const bvalue = bowling;
                                                const sp3value = sp3;
                                                setValue("spcf2", sp3value);
                                                setValue("sp3", bvalue);
                                                setBowling(sp3value);
                                                setsp3(bvalue);
                                                if (aucmoredetail.show.sp1.opt == null || "") {
                                                  if (bvalue == "Other") {
                                                    setother3(other2);
                                                  }
                                                  if (sp3value == "Other") {
                                                    setother2(other3);
                                                  }
                                                }

                                              }
                                              if (
                                                checklist1.includes(
                                                  e.target.value
                                                )
                                              ) {
                                                setschecklist(checklist1);
                                              } else if (
                                                checklist2.includes(
                                                  e.target.value
                                                )
                                              ) {
                                                setschecklist(checklist2);
                                              }

                                              setBatting(e.target.value);
                                            }}
                                          >
                                            <option value={""}>
                                              --
                                              {aucmoredetail.show.sp1.label !==
                                                ""
                                                ? aucmoredetail.show.sp1.label
                                                  .charAt(0)
                                                  .toUpperCase() +
                                                aucmoredetail.show.sp1.label.slice(
                                                  1
                                                )
                                                : "Specification 1"}
                                              --
                                            </option>
                                            {(
                                              aucmoredetail.show.sp1.opt == null ||
                                                aucmoredetail.show.sp1.opt.trim() === ""
                                                ? sp1opt
                                                : aucmoredetail.show.sp1.opt.split(",").map(o => o.trim()).filter(Boolean)
                                            ).map((ele, i) => (
                                              <option key={i} value={ele}>
                                                {ele}
                                              </option>
                                            ))}
                                          </select>
                                          {errors.spcf1 && (
                                            <p className="text-error">
                                              {errors.spcf1.message}
                                            </p>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  {otherBatting ? (
                                    <div className="col-md-6">
                                      <div className="form-group text-box-margin">
                                        <div className="col-md-4">
                                          <label htmlFor="spcf2"> Other </label>
                                        </div>
                                        <div className="col-md-8">
                                          <input
                                            placeholder="Other"
                                            className="form-control"
                                            type="text"
                                            // {...register("spcf1")}
                                            onChange={(e) =>
                                              setother(e.target.value)
                                            }
                                            value={other}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              )}
                            {aucmoredetail &&
                              aucmoredetail.show &&
                              aucmoredetail.show.sp2 &&
                              aucmoredetail.show.sp2.show == 1 && (
                                <div className="col-md-12 margin-top-14px margintop-0px">
                                  <div className="col-md-6">
                                    <div className="form-group text-box-margin addpl-marginbt">
                                      <div className="col-md-4">
                                        <label
                                          htmlFor="spcf2"
                                          className="addpl-label"
                                        >
                                          {" "}
                                          {aucmoredetail.show.sp2.label !== ""
                                            ? aucmoredetail.show.sp2.label
                                              .charAt(0)
                                              .toUpperCase() +
                                            aucmoredetail.show.sp2.label.slice(
                                              1
                                            )
                                            : "Specification 2"}
                                        </label>
                                      </div>
                                      {auctype != 0 ? (
                                        <div className="col-md-8">
                                          {" "}
                                          <input
                                            placeholder={
                                              aucmoredetail.show.sp2.label !==
                                                ""
                                                ? aucmoredetail.show.sp2.label
                                                  .charAt(0)
                                                  .toUpperCase() +
                                                aucmoredetail.show.sp2.label.slice(
                                                  1
                                                )
                                                : "Specification 2"
                                            }
                                            className="form-control addpl-select-control"
                                            type="text"
                                            {...register("spcf2", {})}
                                          />
                                        </div>
                                      ) : (
                                        <div className="col-md-6">
                                          {" "}
                                          <select
                                            className="form-control addpl-select-control"
                                            id="spcf2"
                                            type="text"
                                            {...register("spcf2")}
                                            onChange={(e) => {
                                              if (e.target.value === "Other") {
                                                setOtherBowling(true);
                                              } else {
                                                setOtherBowling(false);
                                              }
                                              setBowling(e.target.value);
                                            }}
                                            value={bowling}
                                          >
                                            <option value={""}>
                                              --
                                              {aucmoredetail.show.sp2.label !==
                                                ""
                                                ? aucmoredetail.show.sp2.label
                                                  .charAt(0)
                                                  .toUpperCase() +
                                                aucmoredetail.show.sp2.label.slice(
                                                  1
                                                )
                                                : "Specification 2"}
                                              --
                                            </option>
                                            {
                                              (aucmoredetail.show.sp2.opt == null || aucmoredetail.show.sp2.opt.trim() === "")
                                                ? (
                                                  batting === "Bowling All Rounder" || batting === "Bowler"
                                                    ? sp3opt.map((ele, idx) => (
                                                      <option key={idx} value={ele}>{ele}</option>
                                                    ))
                                                    : sp2opt.map((ele, idx) => (
                                                      <option key={idx} value={ele}>{ele}</option>
                                                    ))
                                                )
                                                : (
                                                  aucmoredetail.show.sp2.opt
                                                    .split(",")
                                                    .map(o => o.trim())
                                                    .filter(Boolean)
                                                    .map((ele, idx) => (
                                                      <option key={idx} value={ele}>{ele}</option>
                                                    ))
                                                )
                                            }

                                            {/* {batting == "Bowling All Rounder" ||
                                              batting == "Bowler"
                                              ? sp3opt.map((ele) => (
                                                <option value={ele}>
                                                  {ele}
                                                </option>
                                              ))
                                              : sp2opt.map((ele) => (
                                                <option value={ele}>
                                                  {ele}
                                                </option>
                                              ))} */}
                                          </select>
                                          {errors.spcf2 && (
                                            <p className="text-error">
                                              {errors.spcf2.message}
                                            </p>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  {otherBowling ? (
                                    <div className="col-md-6">
                                      <div className="form-group text-box-margin">
                                        <div className="col-md-4">
                                          <label htmlFor="spcf2"> Other </label>
                                        </div>
                                        <div className="col-md-8">
                                          <input
                                            placeholder="Other"
                                            className="form-control"
                                            // {...register("spcf2")}
                                            type="text"
                                            onChange={(e) =>
                                              setother2(e.target.value)
                                            }
                                            value={other2}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              )}
                            {aucmoredetail &&
                              aucmoredetail.show &&
                              aucmoredetail.show.sp3 &&
                              aucmoredetail.show.sp3.show == 1 && (
                                <div className="col-md-12 margin-top-14px margintop-0px">
                                  <div className="col-md-6">
                                    <div className="form-group text-box-margin addpl-marginbt">
                                      <div className="col-md-4">
                                        <label
                                          htmlFor="spcf1"
                                          className="addpl-label"
                                        >
                                          {" "}
                                          {aucmoredetail.show.sp3.label !== ""
                                            ? aucmoredetail.show.sp3.label
                                              .charAt(0)
                                              .toUpperCase() +
                                            aucmoredetail.show.sp3.label.slice(
                                              1
                                            )
                                            : "Specification 3"}
                                        </label>
                                      </div>
                                      {auctype != 0 ? (
                                        <div className="col-md-8">
                                          {" "}
                                          <input
                                            placeholder={
                                              aucmoredetail.show.sp3.label !==
                                                ""
                                                ? aucmoredetail.show.sp3.label
                                                  .charAt(0)
                                                  .toUpperCase() +
                                                aucmoredetail.show.sp3.label.slice(
                                                  1
                                                )
                                                : "Specification 3"
                                            }
                                            className="form-control addpl-select-control"
                                            type="text"
                                            {...register("spcf3", {})}
                                          />
                                        </div>
                                      ) : (
                                        <div className="col-md-6">
                                          {" "}
                                          <select
                                            className="form-control addpl-select-control"
                                            id="spcf3"
                                            type="text"
                                            {...register("spcf3", {
                                              required: false,
                                              // required: "required field.",
                                            })}
                                            onChange={(e) => {
                                              if (e.target.value === "Other") {
                                                setOthersp3(true);
                                              } else {
                                                setOthersp3(false);
                                              }
                                              setsp3(e.target.value);
                                            }}
                                            value={sp3}
                                          >
                                            <option value={""}>
                                              --
                                              {aucmoredetail.show.sp3.label !==
                                                ""
                                                ? aucmoredetail.show.sp3.label
                                                  .charAt(0)
                                                  .toUpperCase() +
                                                aucmoredetail.show.sp3.label.slice(
                                                  1
                                                )
                                                : "Specification 3"}
                                              --
                                            </option>
                                            {
                                              (aucmoredetail.show.sp3.opt == null || aucmoredetail.show.sp3.opt.trim() === "")
                                                ? (
                                                  batting === "Bowling All Rounder" || batting === "Bowler"
                                                    ? sp2opt.map((ele, idx) => (
                                                      <option key={idx} value={ele}>{ele}</option>
                                                    ))
                                                    : sp3opt.map((ele) => (
                                                      <option value={ele}>
                                                        {ele}
                                                      </option>
                                                    ))
                                                )
                                                : (
                                                  aucmoredetail.show.sp3.opt
                                                    ?.split(",")
                                                    .map(o => o.trim())
                                                    .filter(Boolean)
                                                    .map((ele, idx) => (
                                                      <option key={idx} value={ele}>{ele}</option>
                                                    ))
                                                )
                                            }

                                            {/* {batting == "Bowling All Rounder" ||
                                              batting == "Bowler"
                                              ? sp2opt.map((ele) => (
                                                <option value={ele}>
                                                  {ele}
                                                </option>
                                              ))
                                              : sp3opt.map((ele) => (
                                                <option value={ele}>
                                                  {ele}
                                                </option>
                                              ))} */}
                                          </select>
                                          {errors.spcf2 && (
                                            <p className="text-error">
                                              {errors.spcf2.message}
                                            </p>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  {othersp3 ? (
                                    <div className="col-md-6">
                                      <div className="form-group text-box-margin">
                                        <div className="col-md-4">
                                          <label htmlFor="spcf2"> Other </label>
                                        </div>
                                        <div className="col-md-8">
                                          <input
                                            placeholder="Other"
                                            className="form-control"
                                            // {...register("spcf2")}
                                            type="text"
                                            onChange={(e) =>
                                              setother3(e.target.value)
                                            }
                                            value={other3}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              )}


                            <div className="col-md-12 margin-top-14px margintop-0px">
                              <div className="col-md-6">
                                <div className="form-group text-box-margin addpl-marginbt">
                                  <div className="col-md-4">
                                    {" "}
                                    <label
                                      htmlFor="tshirt"
                                      className="addpl-label"
                                    >
                                      {" "}
                                      T-shirt size{" "}
                                    </label>
                                  </div>
                                  <div className="col-md-8">
                                    {" "}
                                    {/* <select
                                      className="form-control"
                                      type="text"
                                      id="tshirt"
                                      {...register("tshirt", {})}
                                    >
                                      <option value="">--select--</option>
                                      <option value="S">S</option>
                                      <option value="M">M</option>
                                      <option value="L">L</option>
                                      <option value="XL">XL</option>
                                      <option value="XXL">XXL</option>
                                      <option value="XXXL">XXXL</option>
                                    </select> */}
                                    <input
                                      placeholder="S/M/L/XL/XXL/XXXL"
                                      className="form-control addpl-input-control"
                                      type="text"
                                      {...register("tshirt", {})}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group text-box-margin addpl-marginbt">
                                  <div className="col-md-4">
                                    {" "}
                                    <label
                                      htmlFor="tshirt"
                                      className="addpl-label"
                                    >
                                      {" "}
                                      Jersey Name
                                    </label>
                                  </div>
                                  <div className="col-md-8">
                                    {" "}
                                    <input
                                      placeholder="Jersey Name"
                                      className="form-control addpl-input-control"
                                      type="text"
                                      {...register("jrnm", {})}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-12 margin-top-14px margintop-0px">
                              <div className="col-md-6">
                                <div className="form-group text-box-margin addpl-marginbt">
                                  <div className="col-md-4">
                                    <label
                                      htmlFor="jrno"
                                      className="addpl-label"
                                    >
                                      {" "}
                                      Jersey Number{" "}
                                    </label>
                                  </div>
                                  <div className="col-md-8">
                                    <input
                                      placeholder="Jersey Number"
                                      className="form-control addpl-input-control"
                                      type="number"
                                      {...register("jrno", {})}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group text-box-margin addpl-marginbt">
                                  <div className="col-md-4">
                                    <label
                                      htmlFor="trouser"
                                      className="addpl-label"
                                    >
                                      {" "}
                                      Trouser Size{" "}
                                    </label>
                                  </div>
                                  <div className="col-md-8">
                                    {/* <select
                                      className="form-control"
                                      id="trouser"
                                      type="text"
                                      {...register("trouser", {})}
                                    >
                                      <option value="">--select--</option>
                                      <option value="S">S</option>
                                      <option value="M">M</option>
                                      <option value="L">L</option>
                                      <option value="XL">XL</option>
                                      <option value="XXL">XXL</option>
                                      <option value="XXXL">XXXL</option>
                                    </select> */}
                                    <input
                                      placeholder="S/M/L/XL/XXL/XXXL"
                                      className="form-control addpl-input-control"
                                      type="text"
                                      {...register("trouser", {})}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-12 margin-top-14px margintop-0px">
                              {" "}
                              <div className="col-md-12">
                                <div className="form-group text-box-margin addpl-marginbt">
                                  <div className="col-md-2">
                                    <label
                                      htmlFor="detail"
                                      className="addpl-label"
                                    >
                                      {" "}
                                      Detail{" "}
                                    </label>
                                  </div>
                                  <div className="col-md-8 margin-left-6px">
                                    <input
                                      className="form-control addpl-input-control"
                                      placeholder="Details"
                                      type="text"
                                      id="detail"
                                      {...register("detail")}
                                    />

                                    {errors.detail && (
                                      <p className="text-error">
                                        {errors.detail.message}
                                      </p>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* {pyqr && pyqr.show == "1" && (
                              <div className="col-md-12 margin-top-14px">
                                <div className="form-group text-box-margin">
                                  <QRContainer>
                                    <QRImageWrapper>
                                      <QRImage
                                        src={`${pyqr.path}${pyqr.qr}`}
                                        alt="Payment QR Code"
                                      />
                                    </QRImageWrapper>
                                    <QRDetailsWrapper>
                                      <QRSectionTitle>
                                        Payment Details
                                      </QRSectionTitle>

                                      <QRDetailRow>
                                        <QRDetailLabel>Name:</QRDetailLabel>
                                        <QRDetailValue>
                                          {pyqr.name}
                                        </QRDetailValue>
                                      </QRDetailRow>

                                      <QRDetailRow>
                                        <QRDetailLabel>UPI ID:</QRDetailLabel>
                                        <QRDetailValue>
                                          {pyqr.mob}
                                        </QRDetailValue>
                                      </QRDetailRow>

                                      <QRDetailRow>
                                        <QRDetailLabel>Fees:</QRDetailLabel>
                                        <QRFeeValue>₹{pyqr.fee}</QRFeeValue>
                                      </QRDetailRow>

                                      <QRInstructions>
                                        Please scan the QR code to make the
                                        payment.
                                      </QRInstructions>
                                    </QRDetailsWrapper>
                                  </QRContainer>
                                </div>
                              </div>
                            )} */}
                            <div className="col-md-12 margin-top-14px">
                              <div className="col-md-12">
                                <div className="form-group text-box-margin addpl-marginbt">
                                  <div className="col-md-2">
                                    <label
                                      htmlFor="jrno"
                                      className="addpl-label"
                                    >
                                      {" "}
                                      Base Value{" "}
                                    </label>
                                  </div>
                                  <div className="col-md-3 margin-left-6px">
                                    <input
                                      placeholder="Base Value"
                                      className="form-control addpl-input-control"
                                      type="number"
                                      step="any"
                                      {...register("base", {})}
                                    />
                                  </div>
                                  <div className="col-md-5">
                                    (If different from Minimum Base or Category
                                    Base Value)
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-12">
                              <button
                                className="button catadd-btns"
                                type="submit"
                                style={{
                                  marginLeft: "24px",
                                  borderRadius: "8px",
                                }}
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Editplayers;
